import React, { useState, useEffect } from "react";
import Classes from "../Profile.module.css";
import { DownloadIcon } from "../../../../../utils/Icons";

const defaultAvatar = "/assets/avatars/profile-red.png";
const MAX_CHARS = 1000;

export default function BasicInfo({ data, update, onNext }) {
  const [form, setForm] = useState(data);
  useEffect(() => setForm(data), [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    update({ [name]: value });
  };

  const handleBioChange = (e) => {
    let { value } = e.target;
    if (value.length > MAX_CHARS) value = value.slice(0, MAX_CHARS);
    setForm((p) => ({ ...p, bio: value }));
    update({ bio: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const preview = URL.createObjectURL(file);
    setForm((p) => ({ ...p, avatar: file, avatarPreview: preview }));
    update({ avatar: file, avatarPreview: preview });
  };

  const handleSubmit = (e) => { e.preventDefault(); onNext(); };

  const avatarSrc =
    form.avatarPreview || (typeof form.avatar === "string" ? form.avatar : null) || defaultAvatar;

  return (
    <form className={Classes.infoCon} onSubmit={handleSubmit}>
      <div className={Classes.changePicCon}>
        <img src={avatarSrc} alt="avatar" className={Classes.avatar} width={80} height={80} draggable={false} />
        <div className={Classes.picActions}>
          <h5 className={Classes.label}>Change Picture</h5>
          <label htmlFor="avatar-input" className={Classes.uploadBtn}>
            <DownloadIcon height="13" width="13" fill="#fff" />
            <h5>Upload Photo</h5>
            <input id="avatar-input" type="file" accept="image/*" hidden onChange={handleFileChange} />
          </label>
        </div>
      </div>

      <div className={Classes.infoConMiddle}>
        {[
          ["name", "Name", "Enter name"],
          ["title", "Professional Title", "Enter job title"],
          ["company", "Company", "Enter company"],
          ["education", "Education Level", "Enter education level"],
          ["school", "School", "Enter school"],
          ["clubs", "Clubs, Fraternities, and Charities", "Enter clubs, charities, or fraternities"],
        ].map(([name, label, placeholder]) => (
          <div className={Classes.flexColGroup} key={name}>
            <div className={Classes.flexCol1}>
              <div className="flexAlign10">
                <h5 className={Classes.label}>{label}</h5>
                {name === "clubs" &&
                  <div className="optionalText"><h5>Optional</h5></div>
                }
              </div>
              <input
                name={name}
                className={Classes.inputField}
                placeholder={placeholder}
                value={form[name] ?? ""}
                onChange={handleChange}
                required={name !== "clubs"}
              />
            </div>
          </div>
        ))}

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Short Bio</h5>
            <div className={Classes.textAreaCon}>
              <textarea
                name="bio"
                className={Classes.textArea}
                rows={5}
                placeholder="Enter bio"
                value={form.bio ?? ""}
                onChange={handleBioChange}
              />
              <h5>{Math.max(0, MAX_CHARS - (form.bio?.length ?? 0))} Characters Remaining</h5>
            </div>
          </div>
        </div>
      </div>

      <button type="submit" className={Classes.saveBtn}><h5>Next</h5></button>
    </form>
  );
}
